import React, { useState, useEffect, useRef } from 'react';
import { GripVertical } from 'lucide-react';

export function SideChatPanel({ vaultId, children }: { vaultId?: string, children?: React.ReactNode, onLaunchGame?: (gameId: string) => void }) {
  const [width, setWidth] = useState(380); // Initial width 380px
  const isResizing = useRef(false);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isResizing.current) return;
      const newWidth = window.innerWidth - e.clientX;
      if (newWidth > 380 && newWidth < 800) {
        setWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      isResizing.current = false;
      document.body.classList.remove('cursor-col-resize');
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div 
      className="bg-[var(--bg-panel)] backdrop-blur-xl border-l border-[var(--stroke)] flex flex-col h-full relative group animate-in slide-in-from-right-10"
      style={{ width: `${width}px`, minWidth: '380px' }}
    >
      {/* Resize Handle */}
      <div 
        className="absolute left-0 top-0 bottom-0 w-1.5 cursor-col-resize hover:bg-[var(--neon)]/20 transition-colors z-50 flex items-center justify-center opacity-0 group-hover:opacity-100"
        onMouseDown={(e) => {
          e.preventDefault();
          isResizing.current = true;
          document.body.classList.add('cursor-col-resize');
        }}
      >
        <GripVertical size={12} className="text-white/20" />
      </div>

      <div className="flex-grow p-0 flex flex-col min-h-0">
        {children || <div className="text-white/50 text-xs p-4 overflow-y-auto">Chat messages will go here...</div>}
      </div>
    </div>
  );
}
